"use strict";

class Dialog extends Widget {
    _element: any;
    _titleBar: any;

    constructor(template: any) {
        super(ui.loadFromTemplate(template));
        ui.addDialog(this);

        this._titleBar = ui.titlebar(this, ".titlebar");
    }

    center() {
        this.centerX();
        this.centerY();
    }

    alignLeftEdge(padding: any) {
        this._element.css("left", padding + "px");
    }

    alignTopEdge(padding: any) {
        this._element.css("top", padding + "px");
    }

    alignRightEdge(padding: any) {
        let width = this._element.width();
        const left = window.innerWidth - width - padding;
        this._element.css("left", left + "px");
    }

    alignBottomEdge(padding: any) {
        let height = this._element.height();
        const top = window.innerHeight - height - padding;
        this._element.css("top", top + "px");
    }

    centerX() {
        const width = this._element.width();
        this._element.css("left", "calc(50% - " + Math.floor(width / 2) + "px)");
    }

    centerY() {
        const height = this._element.height();
        this._element.css("top", "calc(50% - " + Math.floor(height / 2) + "px)");
    }

    // Pull a dialog that would hang off a screen edge back inside (small phone viewports).
    // No-op when it already fits, so desktop positions are untouched.
    _clampToViewport() {
        const r = this._element[0].getBoundingClientRect();
        if (!r.width) return;
        let left = r.left;
        let top = r.top;
        if (r.right > window.innerWidth) left = window.innerWidth - r.width;
        if (r.bottom > window.innerHeight) top = window.innerHeight - r.height;
        left = Math.max(0, left);
        top = Math.max(0, top);
        if (left !== r.left || top !== r.top) {
            this._element.css({ left: left + "px", top: top + "px", right: "auto", bottom: "auto" });
        }
    }

    show() {
        super.show();
        ui.bringToTop(this);
        this._clampToViewport();
    }

    toggle() {
        super.toggle();

        if (this._element.is(":visible")) {
            ui.bringToTop(this);
            this._clampToViewport();
        }
    }

    close() {
        ui.removeDialog(this);
    }
}

ui.Dialog = Dialog;
(global as any).Dialog = Dialog;
ui.dialog = (template: any) => {
    return new ui.Dialog(template);
};
